import { useState, type ChangeEvent } from 'react';
import { Calendar, FileText, Type } from 'lucide-react';
import type { NuevaTareaDraft, Tarea } from '../../types';

interface Props {
  editando: Tarea | null;
  onGuardar: (draft: NuevaTareaDraft) => void;
  onCancelar: () => void;
}

export function FormularioTarea({ editando, onGuardar, onCancelar }: Props) {
  const [titulo, setTitulo] = useState(editando?.titulo ?? '');
  const [fechaLimite, setFechaLimite] = useState(editando?.fechaLimite ?? '');
  const [notas, setNotas] = useState(editando?.notas ?? '');

  const guardar = () => {
    if (!titulo.trim()) {
      alert('Por favor escribe un título');
      return;
    }
    onGuardar({
      titulo: titulo.trim(),
      fechaLimite: fechaLimite || null,
      notas,
    });
  };

  return (
    <div className="bg-white rounded-xl shadow-lg p-6 mb-6">
      <h2 className="text-xl font-bold text-gray-800 mb-4">
        {editando ? '✏️ Editar Tarea' : 'Nueva Tarea'}
      </h2>
      <div className="grid grid-cols-1 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            <Type size={16} className="inline mr-1" />
            Título *
          </label>
          <input
            type="text"
            value={titulo}
            onChange={(e: ChangeEvent<HTMLInputElement>) => setTitulo(e.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-violet-500 focus:border-transparent"
            placeholder="¿Qué tienes que hacer?"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            <Calendar size={16} className="inline mr-1" />
            Fecha límite (opcional)
          </label>
          <input
            type="date"
            value={fechaLimite}
            onChange={(e: ChangeEvent<HTMLInputElement>) => setFechaLimite(e.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-violet-500 focus:border-transparent"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            <FileText size={16} className="inline mr-1" />
            Notas
          </label>
          <textarea
            value={notas}
            onChange={(e: ChangeEvent<HTMLTextAreaElement>) => setNotas(e.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-violet-500 focus:border-transparent"
            rows={5}
            placeholder="Escribe aquí lo que necesites recordar..."
          />
        </div>
      </div>
      <div className="flex gap-3 mt-6">
        <button
          onClick={guardar}
          className="flex-1 bg-violet-600 hover:bg-violet-700 text-white px-6 py-3 rounded-lg font-medium transition-colors"
        >
          {editando ? 'Guardar Cambios' : 'Guardar Tarea'}
        </button>
        <button
          onClick={onCancelar}
          className="px-6 py-3 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
        >
          Cancelar
        </button>
      </div>
    </div>
  );
}
